import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model2InitialModel: ModelData = {
  name: 'Variant 5',
  modelId: 'model2',
  type: 'DOOR',
  description: 'Variant 5',
  width: 2400,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 2400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2000, y: 2440, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2340, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'top_door_glass_panel',
      type: 'GLASS',
      width: 1600,
      height: 380,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: '',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: frameThickness, z: 0 },
    },
    {
      positionId: 'door_glass_panel_1',
      type: 'GLASS',
      width: 800,
      height: 2060,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: '',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 740, y: Math.round(2060 * 0.47), z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: -glassHingeWidth / 3,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 0,
              y: 2060 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 800 - glassLockWidth * 1.5,
              y: 2060 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
    {
      positionId: 'door_glass_panel_2',
      type: 'GLASS',
      width: 800,
      height: 2060,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: '',
      materialId: null,
      isDouble: false,
      position: { x: 1200, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 30, y: Math.round(2060 * 0.47), z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 800 - glassHingeWidth / 2,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 800 - glassHingeWidth,
              y: 2060 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: glassLockWidth,
              y: 2060 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: '',
      materialId: null,
      isDouble: false,
      position: { x: 2000, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'double_door_with_fixed_panels',
    totalDoorWidth: 1600,
    individualDoorWidth: [800, 800],
    totalHandles: 2,
    openingDirection: 'inward_and_outward_swing',
    hingePosition: 'left_and_right',
  },
}
